import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PoweredByDLSoft from "@/components/branding/PoweredByDLSoft";
import { LEGAL_LAST_UPDATED, ORG_INFO } from "./legalMeta";

interface LegalLayoutProps {
  title: string;
  version: string;
  children: React.ReactNode;
}

export default function LegalLayout({
  title,
  version,
  children,
}: LegalLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-primary-600 mb-6"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver al inicio
        </Link>

        <article className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 sm:p-10">
          <header className="mb-8 pb-6 border-b border-gray-100">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">
              {title}
            </h1>
            <p className="mt-3 text-sm text-gray-500">
              <span className="font-semibold">{ORG_INFO.product}</span> ·
              Versión {version} · Última actualización: {LEGAL_LAST_UPDATED}
            </p>
          </header>

          <div className="prose prose-gray max-w-none prose-headings:text-gray-900 prose-h2:text-2xl prose-h2:mt-8 prose-h2:mb-4 prose-h3:text-lg prose-h3:mt-6 prose-h3:mb-3 prose-p:leading-relaxed prose-li:leading-relaxed prose-a:text-primary-600">
            {children}
          </div>

          <footer className="mt-10 pt-6 border-t border-gray-100 text-sm text-gray-500 space-y-1">
            <p>
              Desarrollado por{" "}
              <a
                href={ORG_INFO.developerUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-600 hover:underline font-semibold"
              >
                {ORG_INFO.developer}
              </a>{" "}
              para uso exclusivo de {ORG_INFO.client}.
            </p>
            <p>
              Proyecto sin ánimo de lucro. Contacto:{" "}
              <a
                href={`mailto:${ORG_INFO.contactEmail}`}
                className="text-primary-600 hover:underline"
              >
                {ORG_INFO.contactEmail}
              </a>
            </p>
          </footer>
        </article>

        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link
            to="/register"
            className="text-sm text-primary-600 hover:text-primary-700 font-semibold"
          >
            Volver al registro
          </Link>
          <PoweredByDLSoft theme="light" variant="badge" size="sm" />
        </div>
      </div>
    </div>
  );
}
